import { MessageBar, MessageBarBody } from '@fluentui/react-components';
import { getParameterErrorMessage } from './pricingParameterHelpers';

export interface PricingParameterLoadErrorProps {
  error: unknown;
}

const PricingParameterLoadError = ({ error }: PricingParameterLoadErrorProps) =>
  error ? (
    <MessageBar intent="error">
      <MessageBarBody>
        {getParameterErrorMessage(error, 'Failed to load pricing parameters.')}
      </MessageBarBody>
    </MessageBar>
  ) : null;

export default PricingParameterLoadError;
